import styled from 'styled-components'
import { ImportAndExportIcon, ImportAndExportIconButton } from '../styles'

const ImportIconButton = styled(ImportAndExportIconButton)``

const ImportIcon = styled(ImportAndExportIcon)`
  margin-top: 7px;
`

export { ImportIconButton, ImportIcon }
